import { render, staticRenderFns } from "./StoreAdd.vue?vue&type=template&id=1bf9f5b8&"
import script from "./StoreAdd.vue?vue&type=script&lang=js&"
export * from "./StoreAdd.vue?vue&type=script&lang=js&"
import style0 from "./StoreAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports